module.exports = __webpack_public_path__ + "img/yandex.e4034362.svg";